var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitbucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66116 10.0002C7.2777 9.99529 6.8978 10.0738 6.54815 10.2303C6.19849 10.3868 5.88756 10.6175 5.63718 10.9061C5.38681 11.1947 5.20306 11.5342 5.09886 11.9009C4.99465 12.2676 4.9725 12.6525 5.03397 13.0285L16.1869 80.295C16.3258 81.1181 16.7523 81.8664 17.3913 82.4082C18.0303 82.95 18.8411 83.2508 19.6812 83.2577H73.186C73.8157 83.2657 74.4273 83.0487 74.9094 82.6463C75.3916 82.2438 75.7122 81.6827 75.8129 81.0651L86.9661 13.0416C87.0275 12.6655 87.0053 12.2807 86.901 11.9141C86.7967 11.5474 86.6129 11.2079 86.3625 10.9194C86.1121 10.6309 85.8012 10.4003 85.4516 10.2439C85.1019 10.0874 84.722 10.0089 84.3386 10.0139L7.66116 10.0002ZM54.624 58.6164H37.5466L32.9225 34.6151H58.7621L54.624 58.6164Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.351 34.5859H58.714L54.5791 58.5682H37.5154L17.3672 82.3286C18.0058 82.8772 18.82 83.1822 19.6641 83.1891H73.1395C73.7687 83.1972 74.3799 82.9804 74.8618 82.5783C75.3437 82.1762 75.6641 81.6155 75.7648 80.9984L83.351 34.5859Z",
    fill: "url(#paint0_linear_5972_11648)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5972_11648",
    x1: 18506.1,
    y1: 1584.86,
    x2: 10985.4,
    y2: 11203.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitbucket);
export default __webpack_public_path__ + "static/media/bitbucket.7c035eb5733ec17e0f4ea251f189b67e.svg";
export { ForwardRef as ReactComponent };